import styled from "@emotion/styled";
import { type MantineTheme } from "@mantine/core";

interface ICardContainer {
  userAllowed: string;
  theme?: MantineTheme;
  restricted: string;
}

export const CardContainer = styled.div`
  border-radius: 4px;
  min-height: 180px;
  height: auto;
  background-color: ${({ theme, userAllowed }: ICardContainer) =>
    userAllowed === "true" && theme
      ? theme.colors.cardBackground[0]
      : "#DEE2E6"};
  box-shadow: ${({ theme }) => `${theme.colors.cardBoxShadow[0]} 0px 3px 8px`};
  transition: box-shadow 0.2s;
  color: ${({ theme }) => theme.colors.main};
  padding: 16px 18px 15px 18px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: start;
  border-right: 5px solid ${({ theme }) => theme.colors.main[9]};
  cursor: ${props =>
    props.userAllowed === "true" ? "pointer" : "not-allowed"};

  &:hover {
    box-shadow: ${({ theme, userAllowed }) =>
        userAllowed
          ? theme.colorScheme === "dark"
            ? theme.colors.cardBoxShadow[0]
            : "rgba(0, 0, 0, 0.24)"
          : "none"}
      0px 5px 18px;
  }
`;

export const NoEntries = styled.p`
  color: #b4b4b4;
  font-style: italic;
  margin: 12px 0;
`;

export const BottomText = styled.p`
  color: #868e96;
  font-style: italic;
  margin: 0px 0 0 0;
`;

export const CardName = styled.p`
  margin: 6px 0 0 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const ButtonContainer = styled.div`
  position: relative;
  bottom: 0px;
  display: flex;
  width: 100%;
  justify-content: end;
`;
